module.exports = __webpack_public_path__ + "img/acms-me.7de5ed5f.svg";